/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast. Keeping your custom
* Javascript in this file will make it easier to update Broadcast.
*/


(function () {


  /* =====================================================
     GALERÍA POR COLOR ESTILO MANGO
     Collection product cards
  ===================================================== */


  const mangoGalleryState = new WeakMap();




  /* -----------------------------------------------------
     NORMALIZAR COLOR


     Black       -> black
     Azul Marino -> azul-marino
     Caquí       -> caqui
  ----------------------------------------------------- */


  function normalizeMangoGalleryColor(value) {


    return (value || '')
      .toString()
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');


  }




  /* -----------------------------------------------------
     GUARDAR ESTADO ORIGINAL DEL SLIDER
  ----------------------------------------------------- */


  function getGalleryState(hoverImages) {


    if (mangoGalleryState.has(hoverImages)) {
      return mangoGalleryState.get(hoverImages);
    }


    const slider = hoverImages.querySelector(
      '[data-hover-slider]'
    );


    if (!slider) return null;




    const slides = Array.from(
      slider.querySelectorAll(
        '.product-item__bg__slide'
      )
    );




    /*
      Guardamos cuáles slides tenían originalmente
      data-hover-slide, porque Broadcast no se lo pone
      al primer media.
    */


    slides.forEach(function (slide) {


      slide.dataset.mangoOriginalHoverSlide =
        slide.hasAttribute('data-hover-slide')
          ? 'true'
          : 'false';


    });




    const state = {
      slider: slider,
      slides: slides,
      activeColor: ''
    };




    mangoGalleryState.set(
      hoverImages,
      state
    );


    return state;


  }




  /* -----------------------------------------------------
     DESTRUIR FLICKITY DE FORMA SEGURA
  ----------------------------------------------------- */


  function destroyMangoFlickity(hoverImages) {


    if (!hoverImages.flkty) return;


    hoverImages.flkty.options.watchCSS = false;
    hoverImages.flkty.destroy();
    hoverImages.flkty = null;


  }




  /* -----------------------------------------------------
     RESTAURAR BROADCAST ORIGINAL
  ----------------------------------------------------- */


  function restoreAllSlides(hoverImages, state) {


    if (!window.theme.touch) {
      destroyMangoFlickity(hoverImages);
    }




    state.slides.forEach(function (slide) {


      slide.classList.remove(
        'mango-color-slide-hidden'
      );




      if (
        slide.dataset.mangoOriginalHoverSlide === 'true'
      ) {


        slide.setAttribute(
          'data-hover-slide',
          ''
        );


      } else {


        slide.removeAttribute(
          'data-hover-slide'
        );


      }


    });




    if (window.theme.touch) {


      hoverImages.style.setProperty(
        '--slides-count',
        state.slides.length
      );


      state.slider.scrollLeft = 0;


    } else {


      hoverImages.initFlickity();


    }


  }




  /* -----------------------------------------------------
     ACTIVAR GALERÍA DEL COLOR
  ----------------------------------------------------- */


  function activateMangoColorGallery(
    productItem,
    color
  ) {


    if (
      !productItem ||
      !productItem.hasAttribute(
        'data-mango-color-gallery'
      )
    ) {
      return;
    }




    const hoverImages = productItem.querySelector(
      'hover-images'
    );


    if (!hoverImages) return;




    const state = getGalleryState(
      hoverImages
    );


    if (!state) return;




    const normalizedColor =
      normalizeMangoGalleryColor(color);


    if (!normalizedColor) return;




    /* -----------------------------------------------
       BUSCAR IMÁGENES DEL COLOR
    ----------------------------------------------- */


    const matchingSlides =
      state.slides.filter(function (slide) {


        const slideColor =
          normalizeMangoGalleryColor(
            slide.getAttribute(
              'data-mango-image-color'
            )
          );


        return slideColor === normalizedColor;


      });




    /*
      Si ese color no tiene ninguna imagen etiquetada,
      dejamos Broadcast funcionando normalmente.
    */


    if (!matchingSlides.length) {


      restoreAllSlides(
        hoverImages,
        state
      );


      state.activeColor = '';


      productItem.classList.remove(
        'mango-color-gallery-active'
      );


      return;


    }




    /* -----------------------------------------------
       DESKTOP
    ----------------------------------------------- */


    if (!window.theme.touch) {


      /*
        Destruimos Flickity ANTES de cambiar qué
        elementos pertenecen al slider.
      */


      destroyMangoFlickity(
        hoverImages
      );




      state.slides.forEach(function (slide) {


        slide.classList.remove(
          'mango-color-slide-hidden'
        );




        if (
          matchingSlides.includes(slide)
        ) {


          slide.setAttribute(
            'data-hover-slide',
            ''
          );


        } else {


          slide.removeAttribute(
            'data-hover-slide'
          );


        }


      });




      /*
        Broadcast reconstruye Flickity únicamente
        utilizando los slides con data-hover-slide.
      */


      hoverImages.initFlickity();


    }




    /* -----------------------------------------------
       TOUCH / MOBILE
    ----------------------------------------------- */


    else {


      state.slides.forEach(function (slide) {


        const isMatching =
          matchingSlides.includes(slide);


        slide.classList.toggle(
          'mango-color-slide-hidden',
          !isMatching
        );


      });




      hoverImages.style.setProperty(
        '--slides-count',
        matchingSlides.length
      );




      state.slider.scrollLeft = 0;


    }




    state.activeColor =
      normalizedColor;




    productItem.classList.add(
      'mango-color-gallery-active'
    );


  }




  /* =====================================================
     VINCULAR SWATCHES
  ===================================================== */


  function bindMangoColorGallerySwatches(root) {


    const scope = root || document;




    scope.querySelectorAll(
      '.product-item[data-mango-color-gallery]'
    ).forEach(function (productItem) {




      productItem
        .querySelectorAll(
          '[data-swatch-button]'
        )
        .forEach(function (swatch) {




          if (
            swatch.dataset.mangoGalleryBound === 'true'
          ) {
            return;
          }




          swatch.dataset.mangoGalleryBound =
            'true';




          /* DESKTOP */


          swatch.addEventListener(
            'mouseenter',
            function () {


              const color =
                swatch.getAttribute(
                  'data-tooltip'
                );


              if (!color) return;




              activateMangoColorGallery(
                productItem,
                color
              );


            }
          );




          /* CLICK / TOUCH */


          swatch.addEventListener(
  'click',
  function (event) {


    event.preventDefault();
    event.stopPropagation();


    const color =
      swatch.getAttribute(
        'data-tooltip'
      );


    if (!color) return;


    /* Cambiar galería al color elegido */
    activateMangoColorGallery(
      productItem,
      color
    );


    /* Marcar visualmente el color activo */
    productItem
      .querySelectorAll('[data-swatch-button]')
      .forEach(function (item) {
        item.classList.remove('mango-color-active');
      });


    swatch.classList.add('mango-color-active');


          /* =====================================================
       ACTUALIZAR ENLACE A LA VARIANTE SELECCIONADA
    ===================================================== */


    const variantId =
      swatch.dataset.swatchVariant ||
      swatch.dataset.variant;


    if (variantId) {


      productItem
        .querySelectorAll('[data-product-link]')
        .forEach(function (link) {


          const url = new URL(
            link.href,
            window.location.origin
          );


          url.searchParams.set(
            'variant',
            variantId
          );


          const newUrl =
            url.pathname +
            url.search;


          link.href = newUrl;
          link.dataset.productLink = newUrl;


        });


    }




    /* Cambiar el panel de tallas al color seleccionado */
    const mangoQuickAdd =
      productItem.querySelector('[data-mango-color-size]');


    if (mangoQuickAdd) {


      mangoQuickAdd.setAttribute(
        'data-mango-active-color',
        color
      );


      mangoQuickAdd
        .querySelectorAll('[data-mango-color-panel]')
        .forEach(function (panel) {


          const panelColor =
            panel.getAttribute(
              'data-mango-color-panel'
            );


          panel.classList.toggle(
            'is-active',
            panelColor === color
          );


        });


    }


  }
);


        });


    });


  }




  /* =====================================================
     PRIMERA CARGA
  ===================================================== */


  /* Initialize the first visible color without requiring a swatch click.
     The first image and the gallery arrows must be ready on first hover. */
  function initializeMangoDefaultColor(root) {
    const scope = root || document;
    const cards = [];
    if (scope.matches && scope.matches('.product-item[data-mango-color-gallery]')) cards.push(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('.product-item[data-mango-color-gallery]').forEach(function(card) { cards.push(card); });
    cards.forEach(function(card) {
      if (card.dataset.mangoInitialColorReady === 'true') return;
      const hoverImages = card.querySelector('hover-images');
      if (!hoverImages || typeof hoverImages.initFlickity !== 'function') return;
      const state = getGalleryState(hoverImages);
      if (!state || !state.slides.length) return;
      const firstColor = state.slides[0].getAttribute('data-mango-image-color');
      const firstSwatch = card.querySelector('[data-swatch-button][data-tooltip]');
      const color = firstColor || (firstSwatch && firstSwatch.getAttribute('data-tooltip'));
      if (!color) return;
      const normalized = normalizeMangoGalleryColor(color);
      const matching = state.slides.filter(function(slide) {
        return normalizeMangoGalleryColor(slide.getAttribute('data-mango-image-color')) === normalized;
      });
      if (matching.length < 2) return;
      activateMangoColorGallery(card, color);
      if (state.activeColor === normalized) {
        card.dataset.mangoInitialColorReady = 'true';
        card.querySelectorAll('[data-swatch-button]').forEach(function(swatch) {
          swatch.classList.toggle('mango-color-active', normalizeMangoGalleryColor(swatch.getAttribute('data-tooltip')) === normalized);
        });
      }
    });
  }

  function scheduleMangoDefaultColor(root) {
    requestAnimationFrame(function() {
      initializeMangoDefaultColor(root);
    });
  }

  bindMangoColorGallerySwatches(
    document
  );
  scheduleMangoDefaultColor(document);




  /* Recently viewed is inserted asynchronously after the initial page load.
     Bind its swatches once Shopify has rendered the cards. */
  document.addEventListener('theme:recently-viewed:loaded', function(event) {
    bindMangoColorGallerySwatches(event.target);
    scheduleMangoDefaultColor(event.target);
  }, true);

  /* Prevent a swatch link from navigating to the PDP in Recently viewed.
     Let the existing Mango swatch click handler select the color instead. */
  document.addEventListener('click', function(event) {
    if (event.target.closest('recently-viewed [data-swatch-link]')) {
      event.preventDefault();
    }
  }, true);

  /* =====================================================
     SHOPIFY THEME EDITOR
  ===================================================== */


  document.addEventListener(
    'shopify:section:load',
    function (event) {


      bindMangoColorGallerySwatches(
        event.target
      );
      scheduleMangoDefaultColor(event.target);


    }
  );


  /* =====================================================
   PDP - GALERÍA POR COLOR ESTILO MANGO
===================================================== */


function normalizePdpMangoColor(value) {
  return (value || '')
    .toString()
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}




function getPdpSelectedColor(productInfo) {


  const variantSelects = productInfo.querySelector('variant-selects');


  if (!variantSelects) return '';


  /*
    Buscamos la opción cuyo nombre sea Color / Colour.
  */


  const colorInput = Array.from(
    variantSelects.querySelectorAll('input[type="radio"]:checked')
  ).find(function(input) {


    const name = (input.name || '').toLowerCase();


    return (
      name.includes('color') ||
      name.includes('colour')
    );


  });


  if (colorInput) {
    return colorInput.value;
  }




  /*
    Fallback para dropdown
  */


  const wrappers = variantSelects.querySelectorAll(
    '.selector-wrapper'
  );


  for (const wrapper of wrappers) {


    const label = wrapper.querySelector(
      '.radio__legend__option-name, .radio__legend__label'
    );


    if (!label) continue;


    const labelText = label.textContent
      .trim()
      .toLowerCase();


    if (
      labelText.includes('color') ||
      labelText.includes('colour')
    ) {


      const selected =
        wrapper.querySelector('[data-popout-input]');


      if (selected) {
        return selected.value;
      }


    }


  }


  return '';
}


/* =====================================================
   PDP - LAYOUT DE GALERÍA ESTILO MANGO
   SOLO DESKTOP
===================================================== */


function applyPdpMangoGalleryLayout(productInfo) {


  if (
    !productInfo ||
    productInfo.dataset.mangoGalleryLayout !== 'true'
  ) {
    return;
  }


  const gallery = productInfo.querySelector(
    '[data-product-media-list]'
  );


  if (!gallery) return;




  const allSlides = Array.from(
    gallery.querySelectorAll('.product__slide')
  );




  /* -----------------------------------------------------
     LIMPIAR CLASES ANTERIORES
  ----------------------------------------------------- */


  allSlides.forEach(function(slide) {


    slide.classList.remove(
      'mango-gallery-item',
      'mango-gallery-span-12',
      'mango-gallery-span-6',
      'mango-gallery-span-4',
      'mango-gallery-span-3'
    );


  });




  /*
    Mobile no usa este layout.


    Quitamos las clases pero dejamos funcionar
    el slider mobile normalmente.
  */


  if (window.innerWidth < 750) {
    return;
  }




  /* -----------------------------------------------------
     OBTENER SOLO LAS IMÁGENES VISIBLES
  ----------------------------------------------------- */


  const visibleSlides = allSlides.filter(function(slide) {


    return (
      slide.style.display !== 'none' &&
      !slide.hidden
    );


  });




  const count = visibleSlides.length;


  if (!count) return;




  visibleSlides.forEach(function(slide) {
    slide.classList.add('mango-gallery-item');
  });




  /* -----------------------------------------------------
     FUNCIÓN AUXILIAR
  ----------------------------------------------------- */


  function applySpan(slides, start, amount, spanClass) {


    slides
      .slice(start, start + amount)
      .forEach(function(slide) {


        slide.classList.add(spanClass);


      });


  }




  /* =====================================================
     DISTRIBUCIÓN MANGO
  ===================================================== */




  /* 1 imagen
     [           1           ]
  */


  if (count === 1) {


    applySpan(
      visibleSlides,
      0,
      1,
      'mango-gallery-span-12'
    );


    return;
  }




  /* 2 imágenes
     [     1     ][     2     ]
  */


  if (count === 2) {


    applySpan(
      visibleSlides,
      0,
      2,
      'mango-gallery-span-6'
    );


    return;
  }




  /* 3 imágenes
     [ 1 ][ 2 ]
     [    3    ]
  */


  if (count === 3) {


    applySpan(
      visibleSlides,
      0,
      2,
      'mango-gallery-span-6'
    );


    applySpan(
      visibleSlides,
      2,
      1,
      'mango-gallery-span-12'
    );


    return;
  }




  /* 4 imágenes
     2 + 2
  */


  if (count === 4) {


    applySpan(
      visibleSlides,
      0,
      4,
      'mango-gallery-span-6'
    );


    return;
  }




  /* 5 imágenes
     2 + 3
  */


  if (count === 5) {


    applySpan(
      visibleSlides,
      0,
      2,
      'mango-gallery-span-6'
    );


    applySpan(
      visibleSlides,
      2,
      3,
      'mango-gallery-span-4'
    );


    return;
  }




  /* 6 imágenes
     2 + 2 + 2
  */


  if (count === 6) {


    applySpan(
      visibleSlides,
      0,
      6,
      'mango-gallery-span-6'
    );


    return;
  }




  /* 7 imágenes
     2 + 2 + 3
  */


  if (count === 7) {


    applySpan(
      visibleSlides,
      0,
      4,
      'mango-gallery-span-6'
    );


    applySpan(
      visibleSlides,
      4,
      3,
      'mango-gallery-span-4'
    );


    return;
  }




  /* 8 imágenes
     2 + 2 + 4
  */


  if (count === 8) {


    applySpan(
      visibleSlides,
      0,
      4,
      'mango-gallery-span-6'
    );


    applySpan(
      visibleSlides,
      4,
      4,
      'mango-gallery-span-3'
    );


    return;
  }




  /* 9 imágenes
     2 + 2 + 2 + 3
  */


  if (count === 9) {


    applySpan(
      visibleSlides,
      0,
      6,
      'mango-gallery-span-6'
    );


    applySpan(
      visibleSlides,
      6,
      3,
      'mango-gallery-span-4'
    );


    return;
  }




  /* 10 imágenes
     2 + 2 + 2 + 4
  */


  if (count === 10) {


    applySpan(
      visibleSlides,
      0,
      6,
      'mango-gallery-span-6'
    );


    applySpan(
      visibleSlides,
      6,
      4,
      'mango-gallery-span-3'
    );


    return;
  }




  /* =====================================================
     MÁS DE 10


     Seguimos una lógica automática:
     - filas de 2
     - última fila de 3 o 4 cuando corresponda
  ===================================================== */


  const remainder4 = count % 2 === 0 && count >= 8;


  if (remainder4) {


    const firstPart = count - 4;


    applySpan(
      visibleSlides,
      0,
      firstPart,
      'mango-gallery-span-6'
    );


    applySpan(
      visibleSlides,
      firstPart,
      4,
      'mango-gallery-span-3'
    );


  } else {


    const firstPart = count - 3;


    applySpan(
      visibleSlides,
      0,
      firstPart,
      'mango-gallery-span-6'
    );


    applySpan(
      visibleSlides,
      firstPart,
      3,
      'mango-gallery-span-4'
    );


  }


}


function filterPdpMangoGallery(productInfo) {


  if (
    !productInfo ||
    productInfo.dataset.mangoColorGallery !== 'true'
  ) {
    return;
  }


  const selectedColor =
    normalizePdpMangoColor(
      getPdpSelectedColor(productInfo)
    );


  if (!selectedColor) return;




  const slides = Array.from(
    productInfo.querySelectorAll(
      '.product__slide[data-mango-image-color]'
    )
  );




  const matchingSlides = slides.filter(function(slide) {


    const imageColor =
      normalizePdpMangoColor(
        slide.dataset.mangoImageColor
      );


    return imageColor === selectedColor;


  });




  /*
    Si no encontramos imágenes marcadas para ese color,
    dejamos Broadcast original.
  */


 


  if (!matchingSlides.length) {


    slides.forEach(function(slide) {
      slide.style.removeProperty('display');
    });


     applyPdpMangoGalleryLayout(productInfo);


     productInfo.classList.add('mango-gallery-ready');


    return;
  }




  /*
    Mostrar solamente las imágenes del color seleccionado.
  */


  slides.forEach(function(slide) {


    const imageColor =
      normalizePdpMangoColor(
        slide.dataset.mangoImageColor
      );


    if (imageColor === selectedColor) {
      slide.style.removeProperty('display');
    } else {
      slide.style.setProperty(
        'display',
        'none',
        'important'
      );
    }


  });


  /* Recalcular layout según cantidad de imágenes
   visibles para el color actual */
   applyPdpMangoGalleryLayout(productInfo);


  /*
    También ocultamos thumbnails de otros colores.
  */


  const visibleMediaIds = matchingSlides.map(function(slide) {
    return slide.dataset.mediaId;
  });


  productInfo
    .querySelectorAll('.product__thumb')
    .forEach(function(thumb) {


      const link = thumb.querySelector(
        '[data-media-id]'
      );


      if (!link) return;


      const mediaId =
        link.getAttribute('data-media-id');


      thumb.style.display =
        visibleMediaIds.includes(mediaId)
          ? ''
          : 'none';


    });




  /*
    Seleccionar la primera imagen del color.
  */


const firstSlide = matchingSlides[0];


if (firstSlide) {


  firstSlide.dispatchEvent(
    new CustomEvent(
      'theme:media:select',
      {
        bubbles: true,
        detail: {
          id: firstSlide.dataset.mediaId
        }
      }
    )
  );


}


productInfo.classList.add('mango-gallery-ready');


}






/* =====================================================
   CAMBIO DE COLOR
===================================================== */


document.addEventListener(
  'change',
  function(event) {


    const productInfo =
      event.target.closest('product-info');


    if (!productInfo) return;


    if (
      !event.target.closest(
        'variant-selects'
      )
    ) {
      return;
    }


    requestAnimationFrame(function() {


      filterPdpMangoGallery(
        productInfo
      );


    });


  }
);




/* =====================================================
   PRIMERA CARGA
===================================================== */


document
  .querySelectorAll(
    'product-info[data-mango-color-gallery="true"]'
  )
  .forEach(function(productInfo) {


    filterPdpMangoGallery(
      productInfo
    );


  });


  /* =====================================================
   PRIMERA CARGA - LAYOUT MANGO
===================================================== */


document
  .querySelectorAll(
    'product-info[data-mango-gallery-layout="true"]'
  )
  .forEach(function(productInfo) {


    applyPdpMangoGalleryLayout(
      productInfo
    );


  });


  /* =====================================================
   RECALCULAR AL CAMBIAR TAMAÑO DE PANTALLA
===================================================== */


let mangoGalleryResizeTimer;


window.addEventListener(
  'resize',
  function() {


    clearTimeout(
      mangoGalleryResizeTimer
    );


    mangoGalleryResizeTimer =
      setTimeout(function() {


        document
          .querySelectorAll(
            'product-info[data-mango-gallery-layout="true"]'
          )
          .forEach(function(productInfo) {


            applyPdpMangoGalleryLayout(
              productInfo
            );


          });


      }, 150);


  }
);




/* =====================================================
   VER LOOK - MANGO
===================================================== */

/*
function updateMangoLook(productInfo) {


  if (!productInfo) return;


  const mangoLook =
    productInfo.querySelector('[data-mango-look]');


  if (!mangoLook) return;


  const button =
    mangoLook.querySelector('[data-mango-look-open]');


  if (!button) return;


  const selectedColor =
    normalizePdpMangoColor(
      getPdpSelectedColor(productInfo)
    );


  const groups = Array.from(
    mangoLook.querySelectorAll(
      '[data-mango-look-group]'
    )
  );


  let activeGroup = null;


  groups.forEach(function(group) {


    const groupColor =
      normalizePdpMangoColor(
        group.dataset.mangoLookGroup
      );


    const isActive =
      selectedColor &&
      groupColor === selectedColor;


    group.hidden = !isActive;


    if (
      isActive &&
      group.querySelector(
        '[data-quick-add-holder]'
      )
    ) {
      activeGroup = group;
    }


  });


  /*
    Solo mostramos VER LOOK
    si el color seleccionado tiene productos.
  */

/*
  button.hidden = !activeGroup;
}
*/

function updateMangoLook(productInfo) {
  if (!productInfo) return;

  const mangoLook = productInfo.querySelector('[data-mango-look]');
  if (!mangoLook) return;

  const button = mangoLook.querySelector('[data-mango-look-open]');
  if (!button) return;

  const selectedColor = normalizePdpMangoColor(
    getPdpSelectedColor(productInfo)
  );

  const colorGroups = Array.from(
    mangoLook.querySelectorAll('[data-mango-look-group]')
  );

  const generalGroup = mangoLook.querySelector(
    '[data-mango-look-general]'
  );

  let activeColorGroup = null;

  // Buscar look específico del color seleccionado
  colorGroups.forEach(function(group) {
    const groupColor = normalizePdpMangoColor(
      group.dataset.mangoLookGroup
    );

    const isActive =
      selectedColor &&
      groupColor === selectedColor;

    group.hidden = !isActive;

    if (isActive) {
      activeColorGroup = group;
    }
  });

  // Si hay específico, usar específico.
  // Si no, mostrar el general.
  if (generalGroup) {
    generalGroup.hidden = !!activeColorGroup;
  }

  // Mostrar VER LOOK si existe específico O general.
  button.hidden = !activeColorGroup && !generalGroup;
}

/* =====================================================
   CAMBIO DE COLOR / VARIANTE
===================================================== */


document.addEventListener(
  'change',
  function(event) {


    const productInfo =
      event.target.closest('product-info');


    if (!productInfo) return;


    if (
      !event.target.closest(
        'variant-selects'
      )
    ) {
      return;
    }


    requestAnimationFrame(function() {


      updateMangoLook(
        productInfo
      );


    });


  }
);




/* =====================================================
   ABRIR VER LOOK
===================================================== */


document.addEventListener(
  'click',
  function(event) {


    const button =
      event.target.closest(
        '[data-mango-look-open]'
      );


    if (!button) return;


    const mangoLook =
      button.closest(
        '[data-mango-look]'
      );


    if (!mangoLook) return;


    const dialog =
      mangoLook.querySelector(
        '[data-mango-look-dialog]'
      );


    if (!dialog) return;


    dialog.removeAttribute('inert');


    if (
      typeof dialog.showModal === 'function'
    ) {


      dialog.showModal();


    } else {


      dialog.setAttribute(
        'open',
        ''
      );


    }


    document.dispatchEvent(
      new CustomEvent(
        'theme:scroll:lock',
        {
          bubbles: true,
          detail: dialog
        }
      )
    );


  }
);




/* =====================================================
   CERRAR VER LOOK
===================================================== */


document.addEventListener(
  'click',
  function(event) {


    const button =
      event.target.closest(
        '[data-mango-look-close]'
      );


    if (!button) return;


    const dialog =
      button.closest(
        '[data-mango-look-dialog]'
      );


    if (!dialog) return;


    if (
      typeof dialog.close === 'function'
    ) {


      dialog.close();


    } else {


      dialog.removeAttribute(
        'open'
      );


    }


    dialog.setAttribute(
      'inert',
      ''
    );


    document.dispatchEvent(
      new CustomEvent(
        'theme:scroll:unlock',
        {
          bubbles: true
        }
      )
    );


  }
);




/* =====================================================
   ESCAPE / CIERRE NATIVO
===================================================== */


document.addEventListener(
  'close',
  function(event) {


    const dialog =
      event.target.matches &&
      event.target.matches(
        '[data-mango-look-dialog]'
      )
        ? event.target
        : null;


    if (!dialog) return;


    dialog.setAttribute(
      'inert',
      ''
    );


    document.dispatchEvent(
      new CustomEvent(
        'theme:scroll:unlock',
        {
          bubbles: true
        }
      )
    );


  },
  true
);




/* =====================================================
   PRIMERA CARGA
===================================================== */


document
  .querySelectorAll('product-info')
  .forEach(function(productInfo) {


    updateMangoLook(
      productInfo
    );


  });


  /* =====================================================
   VER LOOK - GALERÍA DE CADA PRODUCTO
===================================================== */


function moveMangoLookGallery(gallery, direction) {


  if (!gallery) return;


  const slides = Array.from(
    gallery.querySelectorAll(
      '[data-mango-look-slide]'
    )
  );


  /* Only navigate slides belonging to the selected color (not hidden slides). */
  const visibleSlides = slides.filter(function(slide) {
    return !slide.hidden;
  });

  if (visibleSlides.length <= 1) return;

  let activeIndex =
    visibleSlides.findIndex(function(slide) {
      return slide.classList.contains('is-active');
    });


  if (activeIndex < 0) {
    activeIndex = 0;
  }


  let nextIndex =
    activeIndex + direction;


  if (nextIndex < 0) {
    nextIndex = visibleSlides.length - 1;
  }


  if (nextIndex >= visibleSlides.length) {
    nextIndex = 0;
  }


  visibleSlides.forEach(function(slide, index) {


    slide.classList.toggle(
      'is-active',
      index === nextIndex
    );


  });


}



/* TOUCH / SWIPE - VER LOOK */
(function enableMangoLookSwipe() {
  let touchStartX = 0;
  let touchStartY = 0;
  let activeGallery = null;
  let didSwipe = false;

  document.addEventListener('touchstart', function(event) {
    const gallery = event.target.closest('[data-mango-look-gallery]');
    if (!gallery || event.touches.length !== 1) return;

    activeGallery = gallery;
    touchStartX = event.touches[0].clientX;
    touchStartY = event.touches[0].clientY;
    didSwipe = false;
  }, { passive: true });

  document.addEventListener('touchend', function(event) {
    if (!activeGallery || !event.changedTouches.length) return;

    const endX = event.changedTouches[0].clientX;
    const endY = event.changedTouches[0].clientY;
    const deltaX = endX - touchStartX;
    const deltaY = endY - touchStartY;

    /* Solo cuenta como swipe si el gesto es claramente horizontal. */
    if (Math.abs(deltaX) >= 35 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2) {
      moveMangoLookGallery(activeGallery, deltaX < 0 ? 1 : -1);
      didSwipe = true;
      activeGallery.dataset.mangoLookJustSwiped = 'true';

      window.setTimeout(function() {
        if (activeGallery) {
          delete activeGallery.dataset.mangoLookJustSwiped;
        }
      }, 350);
    }

    activeGallery = null;
  }, { passive: true });

  document.addEventListener('click', function(event) {
    const link = event.target.closest('.mango-look-product__image-link');
    if (!link) return;

    const gallery = link.closest('[data-mango-look-gallery]');
    if (gallery && gallery.dataset.mangoLookJustSwiped === 'true') {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);
})();



/* FLECHA IZQUIERDA */


document.addEventListener(
  'click',
  function(event) {


    const button =
      event.target.closest(
        '[data-mango-look-gallery-prev]'
      );


    if (!button) return;


    event.preventDefault();
    event.stopPropagation();


    const gallery =
      button.closest(
        '[data-mango-look-gallery]'
      );


    moveMangoLookGallery(
      gallery,
      -1
    );


  }
);




/* FLECHA DERECHA */


document.addEventListener(
  'click',
  function(event) {


    const button =
      event.target.closest(
        '[data-mango-look-gallery-next]'
      );


    if (!button) return;


    event.preventDefault();
    event.stopPropagation();


    const gallery =
      button.closest(
        '[data-mango-look-gallery]'
      );


    moveMangoLookGallery(
      gallery,
      1
    );


  }
);



/* =====================================================
   VER LOOK - SELECTOR DE COLOR
===================================================== */

function updateMangoLookColor(card, colorHandle) {
  if (!card || !colorHandle) return;

  const gallery = card.querySelector('[data-mango-look-gallery]');
  const slides = gallery
    ? Array.from(gallery.querySelectorAll('[data-mango-look-slide]'))
    : [];

  let matchingSlides = slides.filter(function(slide) {
    return slide.dataset.mangoLookColor === colorHandle;
  });

  /* Si ese color no tiene imágenes etiquetadas, no dejamos la tarjeta vacía. */
  if (!matchingSlides.length) {
    matchingSlides = slides;
  }

  slides.forEach(function(slide) {
    const visible = matchingSlides.indexOf(slide) !== -1;
    slide.hidden = !visible;
    slide.classList.remove('is-active');
  });

  if (matchingSlides[0]) {
    matchingSlides[0].hidden = false;
    matchingSlides[0].classList.add('is-active');
  }

  const arrows = gallery
    ? gallery.querySelectorAll('[data-mango-look-gallery-prev], [data-mango-look-gallery-next]')
    : [];

  arrows.forEach(function(arrow) {
    arrow.hidden = matchingSlides.length <= 1;
  });

  card.querySelectorAll('[data-mango-look-color]').forEach(function(button) {
    const selected = button.dataset.mangoLookColor === colorHandle;
    button.classList.toggle('is-active', selected);
    button.setAttribute('aria-pressed', selected ? 'true' : 'false');
  });

  card.querySelectorAll('[data-mango-look-size-color]').forEach(function(item) {
    item.hidden = item.dataset.mangoLookSizeColor !== colorHandle;
  });
}

document.addEventListener('click', function(event) {
  const button = event.target.closest('.mango-look-product__color-swatch[data-mango-look-color]');
  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  const card = button.closest('.mango-look-product');
  updateMangoLookColor(card, button.dataset.mangoLookColor);
});

document.querySelectorAll('.mango-look-product[data-mango-look-initial-color]').forEach(function(card) {
  const initialColor = card.dataset.mangoLookInitialColor;
  if (initialColor) {
    updateMangoLookColor(card, initialColor);
  }
});



})();




/* =====================================================
   FIX MANGO ECUADOR - PRODUCT HOVER FIRST LOAD
   Evita que Flickity recorte la imagen la primera vez
   que se entra con el mouse en una tarjeta de producto.
===================================================== */
(function () {
  const prepared = new WeakSet();
  const preparing = new WeakSet();


  function refreshHoverSlider(hoverImages) {
    if (!hoverImages) return;


    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        const flkty = hoverImages.flkty;


        if (flkty) {
          if (typeof flkty.resize === 'function') flkty.resize();
          if (typeof flkty.reposition === 'function') flkty.reposition();
        }


        hoverImages.classList.remove('mango-hover-preparing');
        prepared.add(hoverImages);
        preparing.delete(hoverImages);
      });
    });
  }


  function prepareHoverImages(hoverImages) {
    if (!hoverImages || prepared.has(hoverImages) || preparing.has(hoverImages)) return;


    preparing.add(hoverImages);
    hoverImages.classList.add('mango-hover-preparing');


    const images = Array.from(
      hoverImages.querySelectorAll('.product-item__bg__slide img')
    );


    if (!images.length) {
      refreshHoverSlider(hoverImages);
      return;
    }


    const waits = images.map(function (img) {
      img.loading = 'eager';


      if (img.complete && img.naturalWidth > 0) {
        return Promise.resolve();
      }


      if (typeof img.decode === 'function') {
        return img.decode().catch(function () {
          return new Promise(function (resolve) {
            img.addEventListener('load', resolve, { once: true });
            img.addEventListener('error', resolve, { once: true });
          });
        });
      }


      return new Promise(function (resolve) {
        img.addEventListener('load', resolve, { once: true });
        img.addEventListener('error', resolve, { once: true });
      });
    });


    Promise.allSettled(waits).then(function () {
      refreshHoverSlider(hoverImages);
    });


    // Fallback: nunca dejar el hover bloqueado si una imagen remota tarda demasiado.
    window.setTimeout(function () {
      if (!prepared.has(hoverImages)) {
        refreshHoverSlider(hoverImages);
      }
    }, 1200);
  }


  function bindHoverFix(root) {
    (root || document).querySelectorAll('hover-images').forEach(function (hoverImages) {
      if (hoverImages.dataset.mangoFirstHoverFix === 'true') return;


      hoverImages.dataset.mangoFirstHoverFix = 'true';


      hoverImages.addEventListener('mouseenter', function () {
        prepareHoverImages(hoverImages);
      }, { passive: true });
    });
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindHoverFix(document);
    });
  } else {
    bindHoverFix(document);
  }


  document.addEventListener('shopify:section:load', function (event) {
    bindHoverFix(event.target);
  });
})();


/* =====================================================
   MANGO ECUADOR — SWATCH IMAGE WITHOUT FLICKER
   Broadcast does not replace the main image src when a
   collection swatch is hovered. It toggles "is-visible"
   on .product-item__bg__inner layers.


   This observer keeps the current layer visible until the
   newly requested color image has actually loaded/decoded.
   Only the requested image is loaded; there is no bulk
   preloading of all color images.
===================================================== */
(function () {
  const CARD_SELECTOR = '[data-grid-item]';
  const LAYER_SELECTOR = '.product-item__bg__inner[data-variant-title]';
  const VISIBLE_CLASS = 'is-visible';


  const boundBackgrounds = new WeakSet();


  function imageReady(img) {
    if (!img) return Promise.resolve();


    // Load only the image the visitor has just requested.
    img.loading = 'eager';


    const waitForLoad = new Promise(function (resolve) {
      if (img.complete && img.naturalWidth > 0) {
        resolve();
        return;
      }


      img.addEventListener('load', resolve, { once: true });
      img.addEventListener('error', resolve, { once: true });
    });


    return waitForLoad.then(function () {
      if (typeof img.decode === 'function') {
        return img.decode().catch(function () {});
      }
    });
  }


  function bindCard(card) {
    if (!card) return;


    const bg = card.querySelector('[data-product-image], .product-item__bg');
    if (!bg || boundBackgrounds.has(bg)) return;


    const layers = Array.from(bg.querySelectorAll(LAYER_SELECTOR));
    if (!layers.length) return;


    boundBackgrounds.add(bg);


    let internalChange = false;
    let requestId = 0;
    let stableLayer = layers.find(function (layer) {
      return layer.classList.contains(VISIBLE_CLASS);
    }) || null;


    let requestedLayer = stableLayer;


    const observer = new MutationObserver(function () {
      if (internalChange) return;


      const newlyVisible = layers.find(function (layer) {
        return layer.classList.contains(VISIBLE_CLASS) && layer !== stableLayer;
      });


      // Broadcast can also remove all variant layers on mouseleave.
      if (!newlyVisible) {
        const anyVisible = layers.find(function (layer) {
          return layer.classList.contains(VISIBLE_CLASS);
        });


        if (!anyVisible) {
          stableLayer = null;
          requestedLayer = null;
        }
        return;
      }


      requestedLayer = newlyVisible;
      const thisRequest = ++requestId;
      const img = newlyVisible.querySelector('img');


      // Undo Broadcast's immediate visual swap before the browser paints.
      internalChange = true;
      newlyVisible.classList.remove(VISIBLE_CLASS);


      if (stableLayer && stableLayer !== newlyVisible) {
        stableLayer.classList.add(VISIBLE_CLASS);
      }
      internalChange = false;


      imageReady(img).then(function () {
        // Visitor may have moved to another swatch while this was loading.
        if (thisRequest !== requestId || requestedLayer !== newlyVisible) return;


        internalChange = true;


        layers.forEach(function (layer) {
          layer.classList.remove(VISIBLE_CLASS);
        });


        newlyVisible.classList.add(VISIBLE_CLASS);
        stableLayer = newlyVisible;


        internalChange = false;
      });
    });


    observer.observe(bg, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }


  function bindAll(root) {
    const scope = root || document;


    if (scope.matches && scope.matches(CARD_SELECTOR)) {
      bindCard(scope);
    }


    scope.querySelectorAll(CARD_SELECTOR).forEach(bindCard);
  }


  function start() {
    bindAll(document);


    // Covers AJAX-loaded recommendations / recently viewed / Shopify sections.
    const pageObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) bindAll(node);
        });
      });
    });


    pageObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }


  document.addEventListener('shopify:section:load', function (event) {
    bindAll(event.target);
  });
})();

/* =============================================================
   LIROGO DIGITAL — QUICK ADD INLINE -> CART DRAWER
   Colecciones: talla simple y color + talla.
   Reutiliza el AJAX nativo del tema (theme:cart:add).
   No modifica el Quick Add modal ni la ficha de producto.
   ============================================================= */
(function () {
  'use strict';

  function sendToNativeCart(button, event) {
    if (!button || button.disabled) return;

    var form = button.form || button.closest('form');
    if (!form || !form.checkValidity()) {
      if (form) form.reportValidity();
      event.preventDefault();
      return;
    }

    // No interferir si el tema está configurado como carrito de página.
    if (!window.theme || !window.theme.settings ||
        window.theme.settings.cartType !== 'drawer' ||
        !document.querySelector('cart-drawer')) {
      return;
    }

    event.preventDefault();
    if (event.type === 'click') event.stopImmediatePropagation();

    if (window.a11y) window.a11y.lastElement = button;

    // El propio tema añade el producto, actualiza cantidades y abre el drawer.
    document.dispatchEvent(new CustomEvent('theme:cart:add', {
      detail: { button: button }
    }));
  }

  // Capture: intercepta el submit nativo antes de navegar a /cart.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-lirogo-quick-add-inline]');
    if (!button) return;
    sendToNativeCart(button, event);
  }, true);

  // Respaldo para envío con teclado u otro submit programático.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form')) return;
    var button = event.submitter;
    if (!button || !button.matches('[data-lirogo-quick-add-inline]')) return;
    sendToNativeCart(button, event);
  }, true);
})();
